import { Get } from ".././MyHelpers";
import {Resource} from "./Resource";
export class AtlasResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "json";
	}
	
	public files: string[] = [];
    public basepath: string = "";

	public constructor(path: string, name: string = null, required: boolean = true) {
		super(path, name, required);

        const pathSeparator = "/";
        this.basepath = path.substring(0, path.lastIndexOf(pathSeparator) + pathSeparator.length);
	}

    public static ParseAtlasFiles(atlas: string): string[]
    {
        let result: string[] = [];

        let lines = atlas.split("\n");

        // first line is file
        if (lines.length > 0)
            result.push(lines[0]);

        // every line after empty line is file
        for (let i = 1; i < lines.length; i++)
        {
            if (lines[i -1] == "")
                result.push(lines[i]);
        }


        return result;
    }

	public Load(preventCache: boolean = false): void {
		Get.Text(
			this.path,
			(success: boolean, status: number, response: string) => {
				if (success) {
					try
					{
						this.files = AtlasResource.ParseAtlasFiles(response);
						this.Loaded();
					}
					catch (ex)
					{
						this.LoadError();
					}
				}
				else {
					this.LoadError();
				}
		});
	}

	public override Reload(preventCache: boolean = false): void {
        this.files = [];
		this.Load(preventCache);
	}
}